<template>
  <div class="quick-start-guides">
    <Layout ref="layoutRef" :selectedOption="4" />

    <!-- Breadcrumb -->
    <div class="mb-3 breadcrumb-container">
      <router-link to="/MenuPrincipal">Inicio</router-link>
      <span class="text-muted"> / Guías</span>
    </div>

    <h4 class="mb-3">Guías de Inicio Rápido</h4>
    <p class="text-muted">
      Encuentra información esencial para comenzar a utilizar el sistema de forma rápida y eficiente.
    </p>

    <!-- Lista de guías -->
    <div v-if="guides.length > 0" class="guides-list">
      <div
        class="guide d-flex align-items-start"
        v-for="(guide, index) in guides"
        :key="index"
      >
        <i class="bi bi-file-earmark-pdf pdf-icon"></i>
        <div class="ms-3">
          <h5 class="mb-1">{{ guide.title }}</h5>
          <p class="mb-2">{{ guide.description }}</p>
          <a
            :href="guide.link"
            class="btn btn-sm btn-outline-primary"
            target="_blank"
            rel="noopener"
          >
            <i class="bi bi-box-arrow-up-right me-1"></i> Abrir PDF
          </a>
        </div>
      </div>
    </div>
    <div v-else class="alert alert-info">
      No existen guías disponibles para su perfil.
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "QuickStartGuides",
  components: { Layout, Footer },
  data() {
    return {
      modulo: 0,
      guides: [],
      guidesPorPerfil: {
        15: [
          {
            title: "Guía rápida: Carga de información en el sistema",
            description: "Instrucciones para cargar la información de atenciones médicas.",
            link: "/docs/AlliKamay - Guía rápida - Carga de información en el sistema.pdf",
          },
        ],
        16: [
          {
            title: "Guía Jefe ACFSS",
            description: "Supervisión de auditorías y control de procesos.",
            link: "/docs/AlliKamay - Guía rápida - Carga de información en el sistema.pdf",
          },
        ],
        17: [
          {
            title: "Guía Supervisor Auditoría Médica",
            description: "Supervisión de la auditoría de pertinencia médica.",
            link: "/docs/AlliKamay - Guía rápida - Carga de información en el sistema.pdf",
          },
        ],
        18: [
          {
            title: "Guía Médico Auditor",
            description: "Proceso de revisión médica de las atenciones.",
            link: "/docs/AlliKamay - Guía rápida - Carga de información en el sistema.pdf",
          },
        ],
        19: [
          {
            title: "Guía Supervisor Gestión Documental",
            description: "Validación y control de documentos cargados.",
            link: "/docs/AlliKamay - Guía rápida - Carga de información en el sistema.pdf",
          },
        ],
        20: [
          {
            title: "Guía Analista Documental",
            description: "Validación de respaldos documentales.",
            link: "/docs/AlliKamay - Guía rápida - Carga de información en el sistema.pdf",
          },
        ],
      },
    };
  },
  mounted() {
    this.modulo = window.sessionStorage.getItem("modulo");
    const perfil = parseInt(window.sessionStorage.getItem("idPerfil"));
    this.guides = this.guidesPorPerfil[perfil] || [];

    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
};
</script>

<style scoped>
.quick-start-guides {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.guides-list .guide {
  background: #fff;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 15px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-left: 5px solid #007bff;
}

.guides-list .guide:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.pdf-icon {
  font-size: 2rem;
  color: #dc3545;
}
</style>
